import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AppConfig } from '@tytapp/common/app-config';
import { environment } from '@tytapp/environment';
import { iframeResizer } from 'iframe-resizer';

@Component({
  selector: 'tyt-embedded-offer-set',
  templateUrl: './embedded-offer-set.component.html',
  styleUrls: ['./embedded-offer-set.component.scss']
})
export class EmbeddedOfferSetComponent implements OnInit {

  @Input()
  offerSetID: string;

  @Input()
  email: string;

  @Input()
  firstName: string;

  @Input()
  showNoThanks: boolean;

  embeddedOfferUrl: SafeUrl;

  constructor(
    private appConfig: AppConfig,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.embeddedOfferUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${environment.urls.accounts}/join/m/${this.offerSetID}/x/pricing?` 
      + `email=${this.email}&firstName=${this.firstName}&theme=dark&showNoThanks=${this.showNoThanks ? 1 : 0}`
    );

    if (typeof window !== 'undefined') {
      setTimeout(() => {
        iframeResizer({ log: true }, '.embeddedOfferFrame')
      }, 500);
    }
  }

}
